<template>
  <van-sticky>
    <ul :class="$style.tabs">
      <!-- 签到福利 -->
      <li :class="!isCompleteSignin && !isSigninToday && $style.badge">
        <button
          :disabled="1 === activeTab"
          :class="1 === activeTab && $style.current"
          @click="onClick(1)"
        />
      </li>
      <!-- 组队赢好礼 -->
      <li :class="!completeLottery && $style.badge">
        <button
          :disabled="2 === activeTab"
          :class="2 === activeTab && $style.current"
          @click="onClick(2)"
        />
      </li>
      <!-- 抽648元代金券 -->
      <li :class="!completeLottery && $style.badge">
        <button
          :disabled="3 === activeTab"
          :class="3 === activeTab && $style.current"
          @click="onClick(3)"
        />
      </li>
    </ul>
  </van-sticky>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'TheTabs',
  props: {
    activeTab: {
      type: Number,
      default: 1
    }
  },
  computed: {
    ...mapGetters(['isSigninToday', 'isCompleteSignin', 'completeLottery'])
  },
  methods: {
    onClick(index) {
      // 触发父组件的滚动事件
      this.$emit('tab-click', index)
    }
  }
}
</script>

<style lang="less" module>
@activeCount: 3;
@activeWidth: 250;
@activeHeight: 111;

.tabs {
  .background-fill('./images/tabs.png', 100% 200%);

  display: flex;
  width: 7.5rem;
  height: 1.11rem;
  margin: 0 auto;

  li {
    flex-shrink: 0;

    .size(@activeWidth * 0.01rem, @activeHeight * 0.01rem);

    .loop(@n) when (@n < @activeCount + 1) {
      &:nth-child(@{n}) .current {
        .sprites-position-x(
            @activeWidth * @activeCount,
            @activeWidth,
            @activeWidth * (@n - 1),
            100%
          );
      }
      .loop(@n+1);
    }
    .loop(1);
  }

  button {
    .size(100%);
  }

  .current {
    .background-fill('./images/tabs.png', 300% 200%);
  }
}

.badge {
  position: relative;

  &::after {
    .size(0.26rem);
    .background-fill('./images/red-badge.png', 100% 100%);

    content: '';
    position: absolute;
    top: 0.1rem;
    right: 0.1rem;
  }
}
</style>
